import { render, staticRenderFns } from "./technologyList.vue?vue&type=template&id=2fa445b0&scoped=true"
import script from "./technologyList.vue?vue&type=script&lang=js"
export * from "./technologyList.vue?vue&type=script&lang=js"
import style0 from "./technologyList.vue?vue&type=style&index=0&id=2fa445b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa445b0",
  null
  
)

export default component.exports